"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
/**
 *
 * @category component
 */
const FilterBoxActions = (props) => {
    const { children } = props;
    return (react_1.default.createElement(Box_1.default, { sx: {
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 3,
        } }, children));
};
exports.default = FilterBoxActions;
